import {isDefined} from "../../libs/utils/epic.utils";
import {JobState} from "../../libs/enum/job-state.enum";

export class CatalogImportStatusDto {

  public readonly type!: string;
  public readonly state!: JobState;
  public readonly started!: Date;
  public readonly completed: Date | undefined;
  public readonly message: string | undefined;
  public readonly resume: Date | undefined;

  constructor(init?: Partial<CatalogImportStatusDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.started)) {
      this.started = new Date(init.started);
    }
    if (isDefined(init?.completed)) {
      this.completed = new Date(init.completed);
    }
    if (isDefined(init?.resume)) {
      this.resume = new Date(init.resume);
    }
  }
}
